<template>
	<div>
		<div class="me">
			<div class="me-info f-cb">
				<div class="me-avatar f-img-box">
					<img :src="data.avatar?data.avatar:studentAvatar">
				</div>
				<div class="me-content">
					<div class="me-name">{{data.nick_name}}</div>
					<div class="me-time">学习时长{{parseInt(data.schedule/60)}}分钟</div>
					<div class="me-line">登录时间 {{data.last_login_time}}</div>
				</div>
			</div>
			<div class="me-links">
				<div class="me-links-link me-links-link-history" @click="to('me-history')">最近学习</div>
				<div class="me-links-link me-links-link-fav" @click="to('me-fav')">我的收藏</div>
				<div class="me-links-link me-links-link-lesson" @click="to('me-lesson')">我的课程</div>
			</div>
			<div class="me-links2">
				<div class="me-links2-link me-links2-link-info" @click="to('me-info')">个人信息</div>
				<div class="me-links2-link me-links2-link-note" @click="to('me-note')">我的笔记</div>
				<div class="me-links2-link me-links2-link-ask" @click="to('me-question')">我的问答</div>
				<div class="me-links2-link me-links2-link-msg" @click="to('me-setting')">设置</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				data:{}
			}
		},
		methods:{
			to(name){
				this.$router.push(name);
			}
		},
		created(){
			this.$api.get("",{
				api:"/v1/my/index",
				user_type:this.tools.getCookie("user_type")
			},
			res => {
				this.data=res.data
			})
		}
	}
</script>

<style scoped>
	.me-info{
		padding:0.8rem 0.4rem 0.4rem 0.4rem;
		border-bottom:1px solid #eee;
	}
	.me-avatar{
		overflow: hidden;
		float:left;
		width:1.946rem;
		height:1.946rem;
		border:1px solid #cfcfcf;
		border-radius: 50%;
	}
	.me-content{
		position: relative;
		float:right;
		margin-top:0.133rem;
		width:6.933rem;
	}
	.me-name{
		font-size: 0.426rem;
		color:#333;
		line-height:0.426rem;
	}
	.me-time{
		margin-top:0.266rem;
		font-size: 0.346rem;
		line-height:0.346rem;
		color:#999;
	}
	.me-line{
		margin-top:0.4rem;
		font-size: 0.346rem;
		color:#333;
		line-height:0.346rem;
	}
	.me-line span{
		margin-left: 1.133rem;
	}
	.me-links{
		text-align: center;
		border-bottom:1px solid #eee;
	}
	.me-links-link{
		display: inline-block;
		width:2.826rem;
		padding-top:2.106rem;
		padding-bottom:0.4rem;
		text-align: center;
		background: center 0.4rem no-repeat;
		background-size: 1.44rem;
		font-size: 0.346rem;
		color:#666;
		line-height:0.346rem;
	}
	.me-links-link-history{
		background-image: url(../me/me-link-history.png);
	}
	.me-links-link-fav{
		background-image: url(../me/me-link-fav.png);
	}
	.me-links-link-lesson{
		background-image: url(../me/me-link-lesson.png);
	}
	.me-links-link-note{
		background-image: url(../me/me-link-note.png);
	}
	.me-links2{
		padding:0 0.4rem;
	}
	.me-links2-link{
		padding-left:1.04rem;
		height:1.28rem;
		line-height:1.28rem;
		background: 0.4rem center no-repeat,9.066rem center no-repeat;
		background-size: 0.373rem,0.133rem;
		border-bottom: 1px solid #eee;
		font-size: 0.426rem;
	}
	.me-links2-link-ask{
		background-image: url(../me/me-links2-ask.png),url(../me/enter.png);
	}
	.me-links2-link-info{
		background-image: url(../me/me-links2-info.png),url(../me/enter.png);
	}
	.me-links2-link-note{
		background-image: url(../me/me-links2-note.png),url(../me/enter.png);
	}
	.me-links2-link-msg{
		background-image: url(../me/me-links2-msg.png),url(../me/enter.png);
	}
	.me-follow{
		position: absolute;
		right:0;
		top:0;
		width:1.506rem;
		height:0.8rem;
		background: #ec6d3a;
		text-align: center;
		line-height:0.8rem;
		color:#fff;
		border-radius: 0.133rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/me/me.vue